/**
 * Created by mly on 2017/12/5.
 * 增删改查公用 数据 和 方法
 * 组件使用 mixins 引入
 */
import RecruitUtil from '../libs/util';
import FlowUtil from '../../../libs/flow_util';
import RecruitNeedUid from '../components/uid';
import ViewerItem from '../../components/viewer/item';
import UserFlowBase from '../../components/flow/user_flow_base';
import {mapGetters} from "vuex";
export default {
    components: { RecruitNeedUid, ViewerItem, UserFlowBase },
    data (){
        return {
            params: {
                per_page: 10,
                page: 1,
                search: '',
                search_type: 'pending'
            },
            page_info: {
                current: 1,
                total: 0,
                page_size: 10
            },
            recruit_needs: [],
            base_columns: [
                {
                    title: '详情',
                    align: 'center',
                    width: 50,
                    render: (h, params) => {
                        const row = params.row;
                        return h(ViewerItem, {
                            props: {
                                type: 'RecruitNeed',
                                model_id: row.id,
                                tip: false
                            },
                            'class': {
                                link: true
                            }
                        }, '查看')
                    }
                },
                {
                    title: '编号',
                    align: 'center',
                    key: 'uid',
                    minWidth: 100,
                    render: (h, params) => {
                        const row = params.row;
                        return h(RecruitNeedUid, {
                            props: {
                                recruit_need: row
                            }
                        });
                    }
                },
                {
                    title: '岗位名称',
                    align: 'center',
                    width: 150,
                    key: 'recruit_job_name'
                },
                {
                    title: '需求团队',
                    align: 'center',
                    minWidth: 80,
                    render: (h, params) => {
                        const row = params.row;
                        const team = this.teams_hash[row.team_id];
                        return h('span', team ? team.name : '-');
                    }
                },
                /*{
                    title: '填制人',
                    align: 'center',
                    width: 80,
                    render: (h, params)=>{
                        let row = params.row;
                        return h('CustomerPoptip', {
                            props: {
                                customer_id: row.fill_user_id
                            },
                            'class': {
                                pointer: true
                            }
                        }, row.fill_user);
                    }
                },*/
                {
                    title: '岗位负责人',
                    align: 'center',
                    Width: 80,
                    render: (h, params) => {
                        const row = params.row;
                        return h('CustomerPoptip', {
                            props: {
                                customer_id: row.apply_user_id
                            },
                            'class': {
                                pointer: true
                            }
                        }, row.apply_user);
                    }
                },
                {
                    title: '工作职责',
                    align: 'center',
                    key: 'job_duty',
                    minWidth: 200,
                    render: (h, params) => {
                        const row = params.row;
                        return h('div', {
                            'class': {
                                'text-left': true
                            },
                            style: {
                                'white-space': 'pre',
                                'overflow': 'hidden',
                                'text-overflow': 'ellipsis'
                            },
                        }, row.job_duty);
                    }
                },
                {
                    title: '状态',
                    minWidth: 125,
                    align: 'center',
                    render: (h, params) => {
                        const row = params.row;
                        const user_flow = row.user_flow;
                        if(user_flow) {
                            return h(UserFlowBase, {
                                props: {
                                    user_flow: user_flow,
                                    model: row,
                                    title: row.recruit_job_name
                                },
                                'class': {
                                    'text-left': true
                                }
                            })
                        }else{
                            return h('div', '-');
                        }
                    }
                }
            ],
            new_recruit_need: Util.clone(RecruitUtil.new_recruit_need),
            loading: false
        }
    },
    computed: {
        cur_customer (){
            return this.$store.state.cur_customer;
        },
        ...mapGetters({
            teams: 'async/root_teams',
            teams_hash: 'async/root_teams_hash',
            offices: 'async/offices',
        }),
    },
    created (){
        //
    },
    mounted (){
        //
    },
    methods: {
        edit (recruit_need){
            this.$refs.editor.edit(recruit_need);
        },
        beforeSearch (){
            this.loading = true;
            this.params.page = 1;
            this.recruit_needs = [];
        },
        pageChange (new_page){
            this.params.page = new_page;
            this.loading = true;
            this.$refs.searchBtn.doAjax(true);
        },
        doSearch (){
            this.params.page = 1;
            this.loading = true;
            this.$refs.searchBtn.doAjax();
        },
        handleData (data){
            this.recruit_needs = data.recruit_needs;
            this.page_info.current = data.cur_page;
            this.page_info.page_size = data.per_page;
            this.page_info.total = data.total_count;
        },
        handleFail (e){
            this.$Modal.error({title: '保存失败', content: e.message});
        },
        handleFinally (){
            this.loading = false;
        },
        updateRecruitNeed (recruit_need){
            if(recruit_need.user_flow){
                Util.insertOrUpdateArrayItem(this.recruit_needs, recruit_need, true);
            }else{
                this.doSearch();
            }
        },
        deleteRecruitNeed (recruit_need){
            this.$Modal.confirm({
                title: '提示',
                content: '你确定要废弃吗?',
                onOk: () => {
                    Util.ajax.post(Util.api.delete_recruit_need, {
                        id: recruit_need.id
                    }).then((response) => {
                        return response.data;
                    }).then((res) => {
                        if(res.code === 1){
                            recruit_need.del = true;
                            this.$Message.success('删除成功!');
                        }else{
                            this.$Modal.error({title: '提示', content: res.msg});
                        }
                    }).catch((e) => {
                        this.$Modal.error({title: '提示', content: e.message});
                    });
                }
            })
        },
        handleEvent (event_name, recruit_need, index){
            console.log(event_name);
            switch (event_name){
                case 'edit':
                    this.edit(recruit_need);
                    break;
                // case 'print':
                //     this.print(recruit_need);
                //     break;
                case 'delete':
                    this.deleteRecruitNeed(recruit_need);
                    break;
                default:
                    this.$Message.error('未定义操作!');
                    break;
            }
        },
    }
}
